import { Injectable } from '@angular/core';

import {
  ControlValidator,
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError
} from '../../types/validator.types';
import { isEmptyInputValue } from '../../utils/utils';

@Injectable()
export class RequiredControlValidator extends ControlValidator {
  constructor() {
    super();
    this.error = new ControlValidatorError(false, ``);
  }

  type = ControlValidatorType.Required;
  validateMoment = ControlValidateMoment.Input;
  validate(): ControlValidatorError {
    const val = this.control.model.value;

    if (isEmptyInputValue(val)) {
      return this.setErrorFalse();
    } else {
      this.error = new ControlValidatorError(true, '');
    }
    return this.error;
  }

  private setErrorFalse(): ControlValidatorError {
    this.error.success = false;
    this.error.message = 'å¿å¡«';
    return this.error;
  }
}
